import styled from 'styled-components'

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  margin-top: 24px;
  padding: 0 24px 40px 24px;

  @media (max-width: 768px) {
    padding: 0 8px 32px 8px;
  }
`

export const TopContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 28px;
`

export const HeroCard = styled.section`
  position: relative;
  overflow: hidden;
  display: flex;
  flex-direction: column;
  gap: 14px;
  padding: 38px 42px;
  border-radius: 28px;
  background:
    radial-gradient(circle at top right, rgba(198, 1, 107, 0.12), transparent 28%),
    radial-gradient(circle at left bottom, rgba(45, 116, 156, 0.14), transparent 30%),
    linear-gradient(180deg, #ffffff 0%, #f8fbff 100%);
  border: 1px solid #d7e0ea;
  box-shadow: 0 18px 40px rgba(22, 50, 71, 0.08);

  @media (max-width: 768px) {
    padding: 28px 22px;
    border-radius: 24px;
  }
`

export const Eyebrow = styled.span`
  display: inline-flex;
  align-items: center;
  width: fit-content;
  padding: 8px 14px;
  border-radius: 999px;
  background: rgba(198, 1, 107, 0.08);
  color: #8f215d;
  font-family: Public Sans;
  font-size: 12px;
  font-weight: 700;
  letter-spacing: 0.08em;
  text-transform: uppercase;
`

export const Title = styled.h1`
  margin: 0;
  max-width: 760px;
  color: #1f2124;
  font-family: Inter;
  font-size: clamp(34px, 5vw, 58px);
  font-style: normal;
  font-weight: 700;
  line-height: 1.02;
  letter-spacing: -0.03em;
`

export const Description = styled.p`
  margin: 0;
  max-width: 760px;
  color: #5e7183;
  font-family: Public Sans;
  font-size: 18px;
  font-weight: 400;
  line-height: 1.7;
`

export const Accent = styled.strong`
  display: block;
  margin-top: 10px;
  color: #c6016b;
  font-family: Inter;
  font-size: clamp(20px, 2.2vw, 28px);
  font-weight: 700;
  line-height: 1.2;
  letter-spacing: -0.02em;
`

export const ButtonContainer = styled.div`
  display: grid;
  grid-template-columns: repeat(2, minmax(260px, 1fr));
  gap: 22px;
  width: 100%;
  max-width: 980px;

  @media (max-width: 900px) {
    grid-template-columns: 1fr;
  }
`

export const ActionCard = styled.button<{ primary?: boolean }>`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 14px;
  min-height: 220px;
  padding: 28px;
  border-radius: 24px;
  border: 1px solid ${(props) => (props.primary ? 'rgba(198, 1, 107, 0.15)' : '#d7e0ea')};
  background: ${(props) =>
    props.primary
      ? 'linear-gradient(145deg, rgba(198, 1, 107, 0.96) 0%, rgba(143, 33, 93, 0.98) 100%)'
      : 'linear-gradient(180deg, #ffffff 0%, #f7fbff 100%)'};
  box-shadow: ${(props) =>
    props.primary ? '0 22px 34px rgba(198, 1, 107, 0.18)' : '0 14px 30px rgba(22, 50, 71, 0.08)'};
  text-align: left;
  cursor: pointer;
  transition: transform 180ms ease, box-shadow 180ms ease, border-color 180ms ease;

  &:hover {
    transform: translateY(-3px);
    box-shadow: ${(props) =>
      props.primary ? '0 26px 36px rgba(198, 1, 107, 0.22)' : '0 18px 34px rgba(22, 50, 71, 0.12)'};
  }

  &:focus-visible {
    outline: 3px solid rgba(45, 116, 156, 0.22);
    outline-offset: 3px;
  }
`

export const CardEyebrow = styled.span<{ primary?: boolean }>`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: fit-content;
  padding: 6px 12px;
  border-radius: 999px;
  background: ${(props) => (props.primary ? 'rgba(255, 255, 255, 0.18)' : 'rgba(45, 116, 156, 0.1)')};
  color: ${(props) => (props.primary ? '#ffffff' : '#2d749c')};
  font-family: Public Sans;
  font-size: 12px;
  font-weight: 700;
  letter-spacing: 0.06em;
  text-transform: uppercase;
`

export const CardTitle = styled.h2<{ primary?: boolean }>`
  margin: 0;
  color: ${(props) => (props.primary ? '#ffffff' : '#163247')};
  font-family: Inter;
  font-size: 30px;
  font-weight: 700;
  line-height: 1.1;
`

export const CardDescription = styled.p<{ primary?: boolean }>`
  margin: 0;
  color: ${(props) => (props.primary ? 'rgba(255, 255, 255, 0.88)' : '#5e7183')};
  font-family: Public Sans;
  font-size: 16px;
  line-height: 1.65;
`

export const CardFooter = styled.div<{ primary?: boolean }>`
  margin-top: auto;
  display: inline-flex;
  align-items: center;
  gap: 8px;
  color: ${(props) => (props.primary ? '#ffffff' : '#163247')};
  font-family: Public Sans;
  font-size: 15px;
  font-weight: 700;
`
